module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/filetree-dir-546b188d2031830763bf4a82a52f1668.svg";